import { constructQueryParams } from "../../_core/utils";
import { AccountLevel, UserLite } from "../../users/api/types";
import { getImpersonationData } from "./identityAPI";
import { UserAuthSession } from "../types";

export const impersonateHubUser = async (targetUser: UserLite, session: UserAuthSession | undefined, accountId: string | void) => {
  try {
    const data = await getImpersonationData(targetUser, session);
    if (!data) throw new Error("Missing data");
    const { hub_url, ...rest } = data;
    const params: any = rest;
    if (targetUser.userAccess.includes(AccountLevel.Account)) {
      params.contextId = accountId;
    }
    const queryParams = constructQueryParams(params);
    const url = `${hub_url}/jwt-login?${queryParams}`;
    return window.open(url, "_blank");
  } catch (error) {
    console.error("Impersonation failed: " + error);
    throw new Error("Impersonation failed");
  }
};
